import { render, staticRenderFns } from "./BatchesCancel.vue?vue&type=template&id=3178eddb&"
import script from "./BatchesCancel.vue?vue&type=script&lang=js&"
export * from "./BatchesCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3178eddb')) {
      api.createRecord('3178eddb', component.options)
    } else {
      api.reload('3178eddb', component.options)
    }
    module.hot.accept("./BatchesCancel.vue?vue&type=template&id=3178eddb&", function () {
      api.rerender('3178eddb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/modals/BatchesCancel.vue"
export default component.exports